module.exports = __webpack_public_path__ + "static/media/instagram_glyph.1e33a081.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile-settings/social/instagram/instagram_glyph.png
// module id = 1984
// module chunks = 0